// const hostname = 'https://localhost:44362'
// const GlobalVariable = Object.freeze({
//     BASE_API_URL: `https://localhost:44462/api/`,
//     BASE_REDIRECT_URL: hostname,
//     AzureB2CUrl: `https://liscrb2cdev.b2clogin.com/identity-dev.liscr.com/oauth2/v2.0/authorize?p=B2C_1A_SIGNUP_SIGNIN&client_id=5cf71554-91e2-4c43-95c2-4254e7dfb511&nonce=defaultNonce&redirect_uri=${hostname}&scope=openid&response_type=id_token&prompt=login`,
//     AzureB2CLogoutUrl: `https://liscrb2cdev.b2clogin.com/identity-dev.liscr.com/B2C_1A_SIGNUP_SIGNIN/oauth2/v2.0/logout?post_logout_redirect_uri=${hostname}&client_id=${localStorage.getItem('token')}`
// })
// export default GlobalVariable

const hostpath = `${window.location.origin}/`
//const hostpath = 'https://localhost:44462/'
const azureAdB2CString = localStorage.getItem('azureAdB2C')
const azureAdB2C = azureAdB2CString ? JSON.parse(azureAdB2CString) : ''
const hostname = azureAdB2C ? azureAdB2C.hostname : ''
let headerText = ''
if (hostname === 'https://localhost:44362') {
    headerText = 'Local Environment'
} else if (hostname === 'https://accounting-dev.liscr.com') {
    headerText = 'Dev Environment'
} else if (hostname === 'https://accounting-tst.liscr.com') {
    headerText = 'Test Environment'
} else if (hostname === 'https://accounting-stg.liscr.com') {
    headerText = 'Stage Environment'
}
const apiUrl = azureAdB2C ? azureAdB2C.apiUrl : ''
const instance = azureAdB2C ? azureAdB2C.instance : ''
const domain = azureAdB2C ? azureAdB2C.domain : ''
const signUpSignInPolicyId = azureAdB2C ? azureAdB2C.signUpSignInPolicyId : ''
const clientId = azureAdB2C ? azureAdB2C.clientId : ''
const GlobalVariable = Object.freeze({
    hostpath,
    BASE_API_URL: `${apiUrl}api/`,
    BASE_REDIRECT_URL: hostname,
    headerText,
    AzureB2CUrl: `${instance}/${domain}/oauth2/v2.0/authorize?p=${signUpSignInPolicyId}&client_id=${clientId}&nonce=defaultNonce&redirect_uri=${hostname}&scope=openid&response_type=code&prompt=login&code_challenge=${azureAdB2C.codeChallenge}&code_challenge_method=S256`,
    AzureB2CLogoutUrl: `${instance}/${domain}/${signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${hostname}&client_id=${localStorage.getItem('token')}`
})
export default GlobalVariable
